import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import "./App.css";
import "./library/css/bootstrap.css";
import Navigation from "./components/navigation/Navigation";
import Alert from "./library/components/Alert/Alert";
import { removeAlert } from "../src/features/alert/alerts";
import SpinnerWithButton from "../src/library/components/SpinnersWithButton/index";
import "./css/common.css";
import "./library/css/fontawesome/css/all.css";
import Signup from "./components/loginPage/signUp/Signup";
import Login from "./components/loginPage/login/login";
import ForgotPasswordScreen from "./components/loginPage/forgotPassword/ForgotPasswordScreen";
import Otp from "./components/loginPage/otp/otp";
import EmailOtp from "./components/loginPage/emailOtp/emailOtp";
import RequestOtp from "./components/loginPage/RequestOtpForServiceVoter/requestOtp";
import OtpForgot from "./components/loginPage/otp/otpForgot";
import SessionIdleTimer from "./components/loginnn/SessionIdleTimer";
import { parseJwt } from "./components/utilities/utils";
import EroDashboard from "./components/Dashboards/ERO/eroDashboard";
import DeoDashboard from "./components/Dashboards/DEO/deoDashboard";
import CeoDashboard from "./components/Dashboards/CEO/ceoDasboard";
import RoDashboard from "./components/Dashboards/RO/roDasboard";
import EciDashboard from "./components/Dashboards/ECI/eciDashboard";
import CEOADashboard from "./components/Dashboards/CEOA/CEOADashboard";
import CommissionDashboard from "./components/Dashboards/COMMISSION/CommissionDashboard";
import HomePage from "./ui/HomePage/HomePage";
import CeoReport from "./components/Dashboards/CEO/ceoReports";
import DeoReport from "./components/Dashboards/DEO/deoReports";
import RoReport from "./components/Dashboards/RO/roReports";
import EciReport from "./components/Dashboards/ECI/EciReports";
import GenerateEpb from "./components/Officers/ReturningOfficer/GenerateEpb";
import RecordOfficerDashboard from "./components/Dashboards/RecordOfficer/recordOfficerDashboard";
import NodalOfficerDashboard from "./components/Dashboards/NodalOfficer/nodalOfficerDashboard";
import UnitOfficerDashboard from "./components/Dashboards/UnitOfficer/unitOfficerDashboard";

import {
  AnnounceElection,
  UploadMasterData,
  FinalizeEpb,
  ReturningOfficer,
  TransmitEpbPin,
  TrackingEpbPin,
  EpbPinDownload,
  GenerateEpbPin,
  ViewEpbByCEO,
  UserList,
  ViewMasterTemplateByECI,
  ApproveNullificationRequests,
  AfterApproveNullification,
  RejectNullification,
  EpbDownloadStatusByRecordOfficer,
  PreCounting,
  Nullification,
  EpbPinUnitDownload,
  FinalizeService,
  EpbDownloadingStatewiseEciReport,
  CountingSupervisorEciReport,
  EpbGenerationDownloadRoReport,
  EpbGenerationDownloadCeoReport,
  EpbGenerationDownloadDeoReport,
  CountingSupervisorDeoReport,
  EpbDownloadingForceWiseEciReport,
  EpbGenerationEciReport,
  EpbDownloadingRecordOfficeWiseEciReport,
  EpbScanningEciReport,
  EpbDownloadingUnitOfficeWiseEciReport,
  EpbScanningCeoReport,
  CountingSupervisorCeoReport,
  EpbScanningDeoReport,
  EpbScanningRoReport,
  CountingSupervisorRoReport,
  Reports,
} from "./components";
import { Header } from "./ui";
import  ScanBallot  from "./components/PreCounting/PreCountingTabs/ScanBallot";
import CountingSupervisorDashboard from './components/Dashboards/CountingSupervisor/countingSupervisorDashboard'
import Downloadbar from "./components/Officers/UnitOfficer/Tabs/Downloadbar";
import Downloads from "./components/Downloads";
import ErollFinalizationStatusCeoReport from "./components/Reports/CEO/ErollFinalizationStatusCeoReport";
import ErollFinalizationStatusDeoReport from "./components/Reports/DEO/ErollFinalizationStatusDeoReport";
import withNav from "./headers/WithNav"
import withOutNav from "./headers/WithoutNav"
import WithNav from "./headers/WithNav";
import WithoutNav from "./headers/WithoutNav";
import VerifyLogin from "./components/loginPage/login/verifyLogin";
import CreateUser from "./components/MasterAdmin/CreateUser";
import EnableDisableDashboard from "./components/DisbaleEnableFeatures/enableDisableDashboard";
import EnableVerificationBallot from "./components/DisbaleEnableFeatures/enableVerificationBallot";
import NoVoterMarkedAcs from "./components/DisbaleEnableFeatures/listOfNoVoterMarked";
import UploadRelease from "./components/MasterAdmin/UploadRelease";
import ScanningCompleted from "./components/DisbaleEnableFeatures/scanningCompleted";
import UnderMaintainance from "./components/UnderMaintainance";
import RecordUnitPendingCount from "./components/Reports/ECIOfficer/RecordUnitPendingCount";
import NodalReports from "./components/Dashboards/NodalOfficer/NodalReport";
import BallotCreation from "./components/BallotCreation/BallotCreation";
import PrecountingCompletionReport from "./components/Reports/ECIOfficer/PrecountingCompletionReport";
import PhaseWiseReport from "./components/Reports/ECIOfficer/phaseWisePendencyreport";
import TestQrScanner from "./components/PreCounting/testQrScanner";
import EpbStatusPhaseWise from "./components/Reports/ECIOfficer/EpbStatusPhaseWise";
import EpbPrecountingSummaryreport from "./components/Reports/ECIOfficer/EpbPrecountingSummaryreport";
import EpbDownloadingPhasewise from "./components/Reports/Nodal/EpbDownloadingPhasewise";
import ControltableUpdation from "./components/MasterAdmin/ControltableUpdation";
import { NotFound } from "./components/loginnn/NotFound";
import Footer from "./components/loginPage/footer";
import { BASE_URLS } from "./constants/constants";

function App() {
  // const { formId } = useParams();
  const [spinIsLoading, setSpinIsLoading] = useState(false);

  const loadingCheck = useSelector((state) => state);
  const showDownloadbar = useSelector((state) => state.downloader.isdownloading);
  const percentage = useSelector((state) => state.downloader.percentage);
  const isLoading = useSelector((state) => state.spinner.isLoading);
  
  useEffect(() => {
    let loadingState = Object.values(getQueries()).some(
      (entry) => entry.status === "pending"
    );
    setSpinIsLoading(loadingState);
  }, [loadingCheck, isLoading]);


  const getQueries = () => {
  let obj = {};
  obj = Object.keys(loadingCheck.commonApi.queries).length
    ? { ...obj, ...loadingCheck.commonApi.queries }
    : { ...obj };
  obj = Object.keys(loadingCheck.objectStoreApi.queries).length
    ? { ...obj, ...loadingCheck.objectStoreApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.objectStoreApi.mutations).length
    ? { ...obj, ...loadingCheck.objectStoreApi.mutations }
    : { ...obj };
  obj = Object.keys(loadingCheck.epbAndPinService.mutations).length
    ? { ...obj, ...loadingCheck.epbAndPinService.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.nullificationServicesApi.mutations).length
    ? { ...obj, ...loadingCheck.nullificationServicesApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.nullificationServicesApi.queries).length
    ? { ...obj, ...loadingCheck.nullificationServicesApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.announceElectionServiceApi.mutations).length
    ? { ...obj, ...loadingCheck.announceElectionServiceApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.announceElectionServiceApi.queries).length
    ? { ...obj, ...loadingCheck.announceElectionServiceApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.finalizeGenerateServiceApi.mutations).length
    ? { ...obj, ...loadingCheck.finalizeGenerateServiceApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.finalizeGenerateServiceApi.queries).length
    ? { ...obj, ...loadingCheck.finalizeGenerateServiceApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.preCoutingServicesApi.mutations).length
    ? { ...obj, ...loadingCheck.preCoutingServicesApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.preCoutingServicesApi.queries).length
    ? { ...obj, ...loadingCheck.preCoutingServicesApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.userServiceApi.mutations).length
    ? { ...obj, ...loadingCheck.userServiceApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.userServiceApi.queries).length
    ? { ...obj, ...loadingCheck.userServiceApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.otpserviceApi.mutations).length
    ? { ...obj, ...loadingCheck.otpserviceApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.reportsServicesApi.mutations).length
    ? { ...obj, ...loadingCheck.reportsServicesApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.reportsServicesApi.queries).length
    ? { ...obj, ...loadingCheck.reportsServicesApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.loginServiceApi.mutations).length
    ? { ...obj, ...loadingCheck.loginServiceApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.loginServiceApi.queries).length
    ? { ...obj, ...loadingCheck.loginServiceApi.queries }
    : { ...obj };
    obj = Object.keys(loadingCheck.captchaServiceApi.mutations).length
    ? { ...obj, ...loadingCheck.captchaServiceApi.mutations }
    : { ...obj };
    obj = Object.keys(loadingCheck.captchaServiceApi.queries).length
    ? { ...obj, ...loadingCheck.captchaServiceApi.queries }
    : { ...obj };
    return obj;
   };

  let userName = localStorage.access_token
    ? parseJwt(localStorage.access_token).name
    : null;

  const Alerts = useSelector((state) => state.alert.alerts);
  let num = Math.floor(Math.random() * 100) + 1;
  const dispatch = useDispatch();
  const onCloseAlert = (id) => {
    dispatch(removeAlert(id));
  };

  return (
//  !loading && 
    <div className="App" style={{    display: "flex",flexDirection: "column",minHeight: "100vh",}} >
      <Router>
          {BASE_URLS.REACT_APP_MAINTAINANCE === "Y" ? (
          <Routes>
            <Route
              path="*"
              element={<UnderMaintainance></UnderMaintainance>}
            ></Route>
          </Routes>
      ) : (
        <>
        {spinIsLoading && (
          <div className="globalSpinnerDiv">
            <SpinnerWithButton spinnerClass="globalSpinner" />
          </div>
        )}
    {showDownloadbar &&<Downloadbar percentage={percentage} />}
        {localStorage?.access_token ? (
          <SessionIdleTimer></SessionIdleTimer>
        ) : null}
        {/* <Navigation userName={userName}></Navigation> */}
        {/* <Header label1={'Electronically Transmitted'} label2={'Postal Ballot System (ETPBS)'} /> */}

        {localStorage?.access_token ? (
          <>
            {/* <Navigation
              userName={userName}
              label1={"Electronically Transmitted"}
              label2={"Postal Ballot Management System (ETPBMS)"}
            ></Navigation> */}
            <div className="" style={{display: "flex",
    flexDirection: "column",
    minHeight: "100vh"}}>
              <Routes>
                {/* <Route path="*" element={<NotFound></NotFound>} /> */}
                <Route element={<WithNav></WithNav>} >
                <Route
                  path="/cs/dashboard"
                  exact
                  element={<CountingSupervisorDashboard/>}
                ></Route>
                <Route
                  path="/com"
                  exact
                  element={<CommissionDashboard></CommissionDashboard>}
                ></Route>
                <Route
                  path="/ceoa"
                  exact
                  element={<CeoDashboard></CeoDashboard>}
                ></Route>
                <Route
                  path="/ero/dashboard"
                  exact
                  element={<EroDashboard></EroDashboard>}
                ></Route>
                <Route
                  path="/deo/dashboard"
                  exact
                  element={<DeoDashboard></DeoDashboard>}
                ></Route>
                <Route
                  path="/ceo/dashboard"
                  exact
                  element={<CeoDashboard></CeoDashboard>}
                ></Route>
                  <Route
                  path="/ceoa/dashboard"
                  exact
                  element={<CeoDashboard></CeoDashboard>}
                ></Route>
                <Route
                  path="/ro/dashboard"
                  exact
                  element={<RoDashboard></RoDashboard>}
                ></Route>
                <Route
                  path="/eci/dashboard"
                  exact
                  element={<EciDashboard></EciDashboard>}
                ></Route>
                 <Route
                  path="/epba/dashboard"
                  exact
                  element={<EciDashboard></EciDashboard>}
                ></Route>
                <Route
                  path="/epbr/dashboard"
                  exact
                  element={<EciDashboard></EciDashboard>}
                ></Route>
                <Route
                  path="/record/dashboard"
                  exact
                  element={<RecordOfficerDashboard></RecordOfficerDashboard>}
                ></Route>
                <Route
                  path="/unit/dashboard"
                  exact
                  element={<UnitOfficerDashboard></UnitOfficerDashboard>}
                ></Route>
                <Route
                  path="/nodal/dashboard"
                  exact
                  element={<NodalOfficerDashboard></NodalOfficerDashboard>}
                >
                </Route>
                <Route
                  path="/ceo/downloads"
                  exact
                  element={<Downloads></Downloads>}
                >
                </Route>
                <Route
                  path="/ceoa/downloads"
                  exact
                  element={<Downloads></Downloads>}
                ></Route>
                <Route
                  path="/ro/downloads"
                  exact
                  element={<Downloads></Downloads>}
                >
                </Route>
                {localStorage.userrole==='ceo' ||localStorage.userrole==='ceoa'|| localStorage.userrole==='ro'||localStorage.userrole==='epbr'||localStorage.userrole==='epba'||localStorage.userrole==='eci'?
                ( <Route
                  path={`/${localStorage.userrole}/users`}
                  exact
                    element={<UserList/>}
                ></Route>):null}
               
                {/* Report */}
                <Route path="/ceo/report" exact element={<CeoReport />}></Route>
                <Route path="/ceoa/report" exact element={<CeoReport />}></Route>
                <Route path="/eci/report" exact element={<EciReport />}></Route>
                <Route path="/epba/report" exact element={<EciReport />}></Route>
                <Route path="/epbr/report" exact element={<EciReport />}></Route>
                <Route path="/ro/report" exact element={<RoReport />}></Route>
                <Route path="/deo/report" exact element={<DeoReport />}></Route>
                <Route path="/nodal/report" exact element={<NodalReports />}></Route>
                <Route
                  path="/ro/TestQrScanner"
                  exact
                  element={<TestQrScanner />}
                ></Route>
                <Route
                  path="/ro/precounting"
                  exact
                  element={<PreCounting />}
                ></Route>
                 <Route
                  path="/ro/scanBallot"
                  exact
                  element={<ScanBallot/>}
                ></Route>

                <Route
                  path="/cs/precounting"
                  exact
                  element={<PreCounting />}
                ></Route>
                <Route
                  path="/ro/generate"
                  exact
                  element={<ReturningOfficer />}
                ></Route>
                <Route
                  path="/ro/transmit-e-PB-pin"
                  exact
                  element={<TransmitEpbPin />}
                ></Route>
                <Route
                  path="/ro/tracking-e-PB-pin-speedpost"
                  exact
                  element={<TrackingEpbPin/>}
                ></Route>
                <Route
                  path="/ro/generateEpb"
                  exact
                  element={<GenerateEpb/>}
                ></Route>
                <Route
                  path="ceo/view-epb"
                  exact
                  element={<ViewEpbByCEO />}
                ></Route>
                <Route
                  path="ceoa/view-epb"
                  exact
                  element={<ViewEpbByCEO />}
                ></Route>
                <Route
                  path="ro/finalepb"
                  exact
                  element={<FinalizeEpb />}
                ></Route>
                 <Route
                  path="ro/ballotCreation"
                  exact
                  element={<BallotCreation />}
                ></Route>
                <Route
                  path="/record/epb-pin-download"
                  exact
                  element={<EpbPinDownload />}
                ></Route>
                 <Route
                  path="/unit/epb-pin-download"
                  exact
                  element={<EpbPinDownload />}
                ></Route>
                {/* <Route
                  path="eci/upload-master"
                  exact
                  element={<UploadMasterData />}
                ></Route> */}
                <Route
                  path="eci/upload-release"
                  exact
                  element={<UploadRelease />}
                ></Route>
                  <Route
                  path="epbr/upload-release"
                  exact
                  element={<UploadRelease />}
                ></Route>
                     <Route
                  path="epba/upload-release"
                  exact
                  element={<UploadRelease />}
                ></Route>
                 <Route
                  path="ceo/create-user"
                  exact
                  element={<CreateUser />}
                ></Route>
                <Route
                  path="ro/create-user"
                  exact
                  element={<CreateUser />}
                ></Route>
                <Route
                  path="ceoa/create-user"
                  exact
                  element={<CreateUser />}
                ></Route>
                <Route
                  path="/ceo/report/epb-precounting-completion-statewise-ceo-report"
                  exact
                  element={<PrecountingCompletionReport />}
                ></Route>
                <Route
                  path="/ceoa/report/epb-precounting-completion-statewise-ceoa-report"
                  exact
                  element={<PrecountingCompletionReport />}
                ></Route>
                 {/* <Route
                  path="epba/upload-master"
                  exact
                  element={<UploadMasterData />}
                ></Route>
                <Route
                  path="epba/upload-master"
                  exact
                  element={<UploadMasterData />}
                ></Route> */}
                <Route path="/users" exact element={<UserList />}></Route>
                <Route
                  path="eci/view-master-template-ECI"
                  exact
                  element={<ViewMasterTemplateByECI />}
                ></Route>
                 <Route
                  path="epba/view-master-template-ECI"
                  exact
                  element={<ViewMasterTemplateByECI />}
                ></Route>
                <Route
                  path="epbr/view-master-template-ECI"
                  exact
                  element={<ViewMasterTemplateByECI />}
                ></Route>
                <Route
                  path="eci/nullification-requests"
                  exact
                  element={<ApproveNullificationRequests />}
                ></Route>
                 <Route
                  path="epba/nullification-requests"
                  exact
                  element={<ApproveNullificationRequests />}
                ></Route>
                  <Route
                  path="epbr/nullification-requests"
                  exact
                  element={<ApproveNullificationRequests />}
                ></Route>
                <Route
                  path="/nullification-requests/after-approve"
                  exact
                  element={<AfterApproveNullification />}
                ></Route>
                <Route
                  path="/nullification-requests/reject-nullification"
                  exact
                  element={<RejectNullification />}
                ></Route>
                <Route path="eci/announce-election" exact element={<AnnounceElection />}></Route>
                <Route path="epba/announce-election" exact element={<AnnounceElection />}></Route>
                <Route path="epbr/announce-election" exact element={<AnnounceElection />}></Route>
                {/* <Route
                  path="/record/dashboard"
                  exact
                  element={<EpbDownloadStatusByRecordOfficer />}
                ></Route> */}
                {/* <Route
                  path="/nodal"
                  exact
                  element={<EpbPinStatusByNodalOfficer />}
                ></Route> */}
                <Route
                  path="unit/epb-ballot-download"
                  exact
                  element={<EpbPinUnitDownload />}
                ></Route>
                <Route
                  path=":role/nullification"
                  exact
                  element={<Nullification />}
                ></Route>
                <Route
                  path="eci/nullification"
                  exact
                  element={<Nullification />}
                ></Route>
                     <Route
                  path="epba/nullification"
                  exact
                  element={<Nullification />}
                ></Route>
                <Route
                  path="ero/finalize-service-voters-ERO"
                  exact
                  element={<FinalizeService />}
                ></Route>
                <Route
                  path="/eci/report/epb-generation-eci-report"
                  exact
                  element={<EpbGenerationEciReport />}
                ></Route>
                <Route
                  path="/eci/report/epb-downloading-statewise-eci-report"
                  exact
                  element={<EpbDownloadingStatewiseEciReport />}
                ></Route>
                <Route
                  path="/eci/report/epb-downloading-forcewise-eci-report"
                  exact
                  element={<EpbDownloadingForceWiseEciReport />}
                ></Route>
                <Route
                  path="/eci/report/epb-downloading-record-officewise-eci-report"
                  exact
                  element={<EpbDownloadingRecordOfficeWiseEciReport />}
                ></Route>
                  <Route
                  path="/nodal/report/epb-downloading-record-officewise-nodal-report"
                  exact
                  element={<EpbDownloadingRecordOfficeWiseEciReport />}
                ></Route>
                  <Route
                  path="/nodal/report/epb-downloading-report-phasewise-nodal-report"
                  exact
                  element={<EpbDownloadingPhasewise />}
                ></Route>
                <Route
                  path="/eci/report/counting-supervisor-eci-report"
                  exact
                  element={<CountingSupervisorEciReport />}
                ></Route>
                <Route
                  path="/eci/report/epb-scanning-eci-report"
                  exact
                  element={<EpbScanningEciReport />}
                ></Route>
                <Route
                  path="/eci/report/epb-downloading-unitofficewise-eci-report"
                  exact
                  element={<EpbDownloadingUnitOfficeWiseEciReport />}
                ></Route>
                   <Route
                  path="/nodal/report/epb-downloading-unitofficewise-nodal-report"
                  exact
                  element={<EpbDownloadingUnitOfficeWiseEciReport />}
                ></Route>
                <Route
                  path="/nodal/report/record-unit-pendency-nodal-report"
                  exact
                  element={<RecordUnitPendingCount />}
                ></Route>
                <Route
                  path="/eci/report/record-unit-pendency-eci-report"
                  exact
                  element={<RecordUnitPendingCount />}
                ></Route>
                <Route
                  path="/eci/report/epb-precounting-completion-statewise-eci-report"
                  exact
                  element={<PrecountingCompletionReport />}
                ></Route>
                <Route
                  path="/eci/report/phaseWise-ePBTransmission-eci-report"
                  exact
                  element={<PhaseWiseReport />}
                ></Route>
                <Route
                  path="/eci/report/ePb-Status-PhaseWise-eci-report"
                  exact
                  element={<EpbStatusPhaseWise />}
                ></Route>
                <Route
                  path="/eci/report/ePb-PreCounting-Summary-eci-report"
                  exact
                  element={<EpbPrecountingSummaryreport />}
                ></Route>
<Route
                  path="/epba/report/epb-generation-epba-report"
                  exact
                  element={<EpbGenerationEciReport />}
                ></Route>
                <Route
                  path="/epba/report/epb-downloading-statewise-epba-report"
                  exact
                  element={<EpbDownloadingStatewiseEciReport />}
                ></Route>
                <Route
                  path="/epba/report/epb-downloading-forcewise-epba-report"
                  exact
                  element={<EpbDownloadingForceWiseEciReport />}
                ></Route>
                <Route
                  path="/epba/report/epb-downloading-record-officewise-epba-report"
                  exact
                  element={<EpbDownloadingRecordOfficeWiseEciReport />}
                ></Route>
                <Route
                  path="/epba/report/counting-supervisor-epba-report"
                  exact
                  element={<CountingSupervisorEciReport />}
                ></Route>
                <Route
                  path="/epba/report/epb-scanning-epba-report"
                  exact
                  element={<EpbScanningEciReport />}
                ></Route>
                <Route
                  path="/epba/report/epb-downloading-unitofficewise-epba-report"
                  exact
                  element={<EpbDownloadingUnitOfficeWiseEciReport />}
                ></Route>
                <Route
                  path="/epba/report/record-unit-pendency-eci-report"
                  exact
                  element={<RecordUnitPendingCount />}
                ></Route>
<Route
                  path="/epba/report/epb-precounting-completion-statewise-eci-report"
                  exact
                  element={<PrecountingCompletionReport />}
                ></Route>
                <Route
                  path="/epba/report/phaseWise-ePBTransmission-eci-report"
                  exact
                  element={<PhaseWiseReport />}
                ></Route>
                <Route
                  path="/epba/report/ePb-Status-PhaseWise-eci-report"
                  exact
                  element={<EpbStatusPhaseWise />}
                ></Route>
                <Route
                  path="/epba/report/ePb-PreCounting-Summary-eci-report"
                  exact
                  element={<EpbPrecountingSummaryreport />}
                ></Route>
<Route
                  path="/epbr/report/epb-generation-epbr-report"
                  exact
                  element={<EpbGenerationEciReport />}
                ></Route>
                <Route
                  path="/epbr/report/epb-downloading-statewise-epbr-report"
                  exact
                  element={<EpbDownloadingStatewiseEciReport />}
                ></Route>
                <Route
                  path="/epbr/report/epb-downloading-forcewise-epbr-report"
                  exact
                  element={<EpbDownloadingForceWiseEciReport />}
                ></Route>
                <Route
                  path="/epbr/report/epb-downloading-record-officewise-epbr-report"
                  exact
                  element={<EpbDownloadingRecordOfficeWiseEciReport />}
                ></Route>
                <Route
                  path="/epbr/report/counting-supervisor-epbr-report"
                  exact
                  element={<CountingSupervisorEciReport />}
                ></Route>
                <Route
                  path="/epbr/report/epb-scanning-epbr-report"
                  exact
                  element={<EpbScanningEciReport />}
                ></Route>
                <Route
                  path="/epbr/report/epb-downloading-unitofficewise-epbr-report"
                  exact
                  element={<EpbDownloadingUnitOfficeWiseEciReport />}
                ></Route>
                <Route
                  path="/epbr/report/record-unit-pendency-eci-report"
                  exact
                  element={<RecordUnitPendingCount />}
                ></Route>
                   <Route
                  path="/epbr/report/epb-precounting-completion-statewise-eci-report"
                  exact
                  element={<PrecountingCompletionReport />}
                ></Route>
                <Route
                  path="/epbr/report/phaseWise-ePBTransmission-eci-report"
                  exact
                  element={<PhaseWiseReport />}
                ></Route>
                <Route
                  path="/epbr/report/ePb-Status-PhaseWise-eci-report"
                  exact
                  element={<EpbStatusPhaseWise />}
                ></Route>
                <Route
                  path="/epbr/report/ePb-PreCounting-Summary-eci-report"
                  exact
                  element={<EpbPrecountingSummaryreport />}
                ></Route>
                  <Route
                  path="/ceo/enable_disable/Operation"
                  exact
                  element={<EnableDisableDashboard />}
                ></Route>
                <Route
                  path="/ceo/enable_disable/ballot_verfication"
                  exact
                  element={<EnableVerificationBallot />}
                ></Route>
                     <Route
                  path="/ceo/enable_disable/no_voter_marked"
                  exact
                  element={<NoVoterMarkedAcs />}
                ></Route>
                  <Route
                  path="/ceo/enable_disable/scanning_completed"
                  exact
                  element={<ScanningCompleted />}
                ></Route>
  <Route path=":role/accessNotAllowed" element={<NotFound />}></Route>
<Route
                  path="/ceoa/enable_disable/Operation"
                  exact
                  element={<EnableDisableDashboard />}
                ></Route>
                <Route
                  path="/ceoa/enable_disable/ballot_verfication"
                  exact
                  element={<EnableVerificationBallot />}
                ></Route>
                     <Route
                  path="/ceoa/enable_disable/no_voter_marked"
                  exact
                  element={<NoVoterMarkedAcs />}
                ></Route>
                   <Route
                  path="/ceoa/enable_disable/scanning_completed"
                  exact
                  element={<ScanningCompleted />}
                ></Route>

                <Route path="/ceo/report/epb-generation-download-ceo-report"exact element={<EpbGenerationDownloadCeoReport/>}></Route>
                <Route path="/ceo/report/epb-scanning-ceo-report"exact element={<EpbScanningCeoReport/>}></Route>
                <Route path="/ceo/report/counting-supervisor-ceo-report"exact element={<CountingSupervisorCeoReport/>}></Route>
                <Route path="/ceo/report/eroll-finalization-status-ceo-report"exact element={<ErollFinalizationStatusCeoReport/>}></Route>

                <Route path="/ceoa/report/epb-generation-download-ceoa-report"exact element={<EpbGenerationDownloadCeoReport/>}></Route>
                <Route path="/ceoa/report/epb-scanning-ceoa-report"exact element={<EpbScanningCeoReport/>}></Route>
                <Route path="/ceoa/report/counting-supervisor-ceoa-report"exact element={<CountingSupervisorCeoReport/>}></Route>
                <Route path="/ceoa/report/eroll-finalization-status-ceoa-report"exact element={<ErollFinalizationStatusCeoReport/>}></Route>


                <Route path="/deo/report/epb-generation-download-deo-report"exact element={<EpbGenerationDownloadDeoReport/>}></Route>
                <Route path="/deo/report/counting-supervisor-deo-report"exact element={<CountingSupervisorDeoReport/>}></Route>
                <Route path="/deo/report/epb-scanning-deo-report"exact element={<EpbScanningDeoReport/>}></Route>
                <Route path="/deo/report/eroll-finalization-status-deo-report"exact element={<ErollFinalizationStatusDeoReport/>}></Route>

                <Route path="/ro/report/epb-generation-download-ro-report"exact element={<EpbGenerationDownloadRoReport/>}></Route>
                <Route path="/ro/report/counting-supervisor-ro-report"exact element={<CountingSupervisorRoReport/>}></Route>
                <Route path="/ro/report/epb-scanning-ro-report"exact element={<EpbScanningRoReport/>}></Route>
                <Route path="/ro/report/all-reports" exact element={<Reports/>}></Route>
                <Route path="/epba/control-table" exact element={<ControltableUpdation/>}></Route>
                <Route path="/epbr/control-table" exact element={<ControltableUpdation/>}></Route>
                <Route path="/" element={<Login />}></Route>
                <Route path ="/*"></Route>
                </Route>
              </Routes>
                <Footer />
            </div>
          </>
        ) : (
          <>
          <Routes>
            {/* <Route path="*" element={<Login></Login>} */}
           
            <Route element={<WithNav></WithNav>}>
            <Route path="/login" exact element={<Login />}></Route>
            <Route path="/verifylogin" exact element={<VerifyLogin />}></Route>
            <Route path="*" element={<Login />}></Route>
            <Route path="/" element={<Login />}></Route>
            <Route
              path="/otp"
              exact
              element={    
                  <Otp />
              }
            ></Route>
              <Route path="/login" exact element={<Login />}></Route>
             <Route
                path="/login"
                exact
                element={
                    <Login />
                }
              ></Route>
               <Route
                path="/forgotpassword"
                exact
                element={
                  <ForgotPasswordScreen />
                }
              ></Route>
               <Route
                path="/signUp"
                exact
                element={
                  <Signup />
                }
              ></Route>
               <Route
                path="/otp"
                exact
                element={
                  <Otp />
                }
              ></Route>
               <Route
                path="/emailotp"
                exact
                element={
                  <EmailOtp />
                
                }
              ></Route>
              <Route
                path="/requestotp"
                exact
                element={
                  <RequestOtp />

                }
              ></Route>
              <Route
                path="/otpforgot"
                exact
                element={
                  <OtpForgot />
                }
              ></Route>
            </Route>
          </Routes>
   <Footer />
</>
        )}
        <div className="alert_global">
          {Alerts.map((item, index) => {
            return (
              <Alert
                key={index}
                id={item.id}
                type={item.type}
                heading={item.heading}
                message={item.message}
                onClick={() => onCloseAlert(item.id)}
                autoClose={true}
                time={5000}
              />
            );
          })}
        </div>
        </>
      )}
      </Router>
    </div>
  
  );
}

export default App;
